import React, { useState } from 'react';
import { Offcanvas } from 'reactstrap';
import classNames from 'classnames';

import FileArea from '~components/file-area';
import Icon, { faChevronLeft, faChevronRight } from '~components/icon';

import { InvoiceFile } from '~support-at-home/models';

interface ComponentProps {
  isOpen: boolean;
  onChange: (event: File) => void;
  onToggleCollapse?: (toggle: boolean) => void;
  isExisting?: boolean;
  selectorFiles: InvoiceFile[];
  onFileDeleted?: () => void;
  onAnalyse?: (fileId: string) => void;
  isAnalysing?: boolean;
  analyseEnabled?: boolean;
}

const FileOffCanvas: React.FC<ComponentProps> = ({
  isOpen,
  onChange,
  onToggleCollapse,
  isExisting,
  selectorFiles,
  onFileDeleted,
  onAnalyse,
  isAnalysing = false,
  analyseEnabled = false,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggle = () => {
    const value = !isCollapsed;
    setIsCollapsed(value);
    onToggleCollapse?.(value);
  };

  const className = classNames('file-upload-modal feature', {
    collapse: isCollapsed,
  });

  const areaClassName = classNames({
    collapse: isCollapsed,
  });

  return (
    <Offcanvas isOpen={isOpen} className={className} backdrop={false}>
      <div className="area-container">
        <FileArea
          onChange={onChange}
          className={areaClassName}
          isExisting={isExisting}
          selectorFiles={selectorFiles}
          onFileDeleted={onFileDeleted}
          onAnalyse={onAnalyse}
          isAnalysing={isAnalysing}
          analyseEnabled={analyseEnabled && !isCollapsed}
        />
        <div className="toggle" onClick={toggle}>
          <Icon className="icon" icon={!isCollapsed ? faChevronLeft : faChevronRight} />
        </div>
      </div>
    </Offcanvas>
  );
};

export default FileOffCanvas;
